module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.6807e653.woff";